import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  waitOrderCount = 0;

  constructor(private http: HttpService) {
    this.getWaitOrderCount();
  }

  /** 승인 대기 주문 개수 */
  async getWaitOrderCount() {
    try {
      const waitOrderList = await this.http.get(
        '/work_waiting_approval?select=id, work_instruction_id, instruction_type, input_quantity, memo, memo_updated_at, is_accepted, orders(id, clients(name), order_number, order_date, due_date, items(id,name, model_name, code_number, stocks))&is_accepted=eq.false&is_canceled=eq.false'
      );
      this.waitOrderCount = waitOrderList.length;
    } catch (error) {}
  }
}
